import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { SectionTitle } from "./Sections";

const VIDEOS = [
  { id: "GZmwztEFkDw", cat: "demo" },
  { id: "v_ppk7wMPUY", cat: "testimonial" },
  { id: "1ogPxOQGTuw", cat: "application" },
  { id: "6ZfYxkF_vRo", cat: "demo" },
  { id: "gK8rBR2fmmI", cat: "demo" },
  { id: "J7NQ7HzQt_8", cat: "testimonial" },
  { id: "B5OEkC7uDZg", cat: "application" },
  { id: "Gc-JIEsOgHg", cat: "demo" },
  { id: "497yjDHPxQg", cat: "application" },
];

const VideoCard = ({ video, large, title }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="bg-white rounded-3xl overflow-hidden border border-brand-green/15 shadow-[0_8px_30px_rgba(109,76,65,0.08)] hover:-translate-y-1 transition-transform h-full flex flex-col">
      <div className="relative bg-black group aspect-video">
        {loaded ? (
          <iframe className="w-full h-full absolute inset-0" loading="lazy"
            src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1`}
            title={title} allow="autoplay; encrypted-media" allowFullScreen />
        ) : (
          <button data-testid={`video-play-${video.id}`} onClick={() => setLoaded(true)} className="w-full h-full relative block">
            <img src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`} alt={title}
              className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className={`${large ? "w-20 h-20" : "w-14 h-14"} rounded-full bg-brand-orange text-white flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform`}>
                <Play size={large ? 32 : 22} fill="white" />
              </span>
            </span>
          </button>
        )}
      </div>
      <div className={`px-5 py-4 flex-1 ${large ? "sm:px-6" : ""}`}>
        <h3 data-testid={`video-title-${video.id}`}
          className={`font-bold text-brand-dark leading-snug ${large ? "text-base sm:text-lg" : "text-sm"}`}>
          {title}
        </h3>
      </div>
    </div>
  );
};

export const VideoShowcase = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("all");
  const filters = ["all", "demo", "testimonial", "application"];
  const shown = VIDEOS.filter((v) => filter === "all" || v.cat === filter);

  return (
    <section id="videos" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionTitle title={t("videos.title")} subtitle={t("videos.subtitle")} />
        <div className="flex flex-wrap gap-3 mb-10">
          {filters.map((f) => (
            <button key={f} data-testid={`video-filter-${f}`} onClick={() => setFilter(f)}
              className={`px-5 py-2 rounded-full text-sm font-bold transition-colors ${
                filter === f ? "bg-brand-orange text-white" : "bg-brand-cream text-brand-brown border border-brand-green/20 hover:bg-brand-yellow"}`}>
              {t(`videos.${f}`)}
            </button>
          ))}
        </div>
        <motion.div layout className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {shown.map((v, i) => (
            <motion.div key={v.id} layout initial={{ opacity: 0 }} animate={{ opacity: 1 }}
              className={i === 0 ? "md:col-span-12 lg:col-span-8" : "md:col-span-6 lg:col-span-4"}>
              <VideoCard video={v} large={i === 0} title={t(`videos.titles.${v.id}`)} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
